import { Component, Fragment } from 'react'
import styled from 'glamorous'
import Route from 'react-router-dom/Route'
import Switch from 'react-router-dom/Switch'
import { withRouter } from 'react-router-dom'
import { graphql } from 'react-apollo'
import range from 'lodash/range'
import { $, getUrlSearch, getLocationQuery } from 'utils'
import { Button, InnerLayout, PaginationBar, EmptyLayout, Loader, EmptyDetails, FileButton } from 'components'
import { DESCRIPTORS } from 'queries'
import { withConsumer } from 'store'

import ExtractPage from './ExtractPage'
import FacesList from './FacesList'
import DetailsPage from './DetailsPage'

const Header = styled.div({
  display: 'flex',
  justifyContent: 'space-between'
})

const HeaderButtons = styled.div({
  display: 'flex',
  justifyContent: 'flex-end',
  width: 462
})

// const SelectContainer = styled.div({
//   flexGrow: 1
// })

const AddContainer = styled.div({
  position: 'relative',
  display: 'flex',
  justifyContent: 'flex-end',
  marginLeft: 10,
  width: 124,
  overflow: 'hidden',
  transition: 'width var(--transition)',
  '& .btnAddFromCam': {
    opacity: 0,
    marginRight: 10,
    transform: 'translateX(20px)',
    transition: 'transform var(--transition), opacity var(--transition)',
  },
  '&:hover': {
    width: 258,
    '& .btnAddFromCam': {
      opacity: 1,
      transform: 'translateX(0)',
      '&:hover': {
        opacity: 0.8
      }
    }
  }
})

const DetailsContainer = styled.div({
  position: 'relative',
  width: '100%',
  height: '100%',
  overflow: 'hidden'
})

export class Faces extends Component {

  state = {
    photo: null,
    file: null,
    isExtractView: false,
    extractedFaces: [],
    extracted: false,
  }

  addPhoto = () => {
    const file = this.input.files[0];
    const reader  = new FileReader();
    reader.onloadend = () => {
      this.setState({ photo: reader.result, file, extractedFaces: [], extracted: false,
        isExtractView: true }, () => this.input.value = '')
    }
    if (file) {
      reader.readAsDataURL(file);
    } else {
      this.setState({ photo: null })
    }
  }

  onExtract = ({ extractedFaces, extracted }) => {
    this.setState({
      extractedFaces,
      extracted
    })
  }

  showExtractPanel = (isExtractView) => {
    this.setState({
        isExtractView
      },
      () => !isExtractView && setTimeout(this.clearPhoto, 1000)
    )
  }

  clearPhoto = () => {
    this.setState({ photo: null })
  }

  changePage = (value) => {
    const { history, location, data: { variables: vars } } = this.props
    const search = getUrlSearch({...vars, offset: value})
    history.push({
      pathname: location.pathname,
      search,
    })
  }

  renderExtractPanel = (fixed = false) =>
    this.state.isExtractView &&
      $(ExtractPage, {
        fixed,
        extractedFaces: this.state.extractedFaces,
        extracted: this.state.extracted,
        onExtract: this.onExtract,
        photo: this.state.photo,
        file: this.state.file,
        closePanel: () => this.showExtractPanel(false),
      })

  render = () => {
    const { photo, isExtractView } = this.state
    const { data: { loading, descriptors, variables: vars } } = this.props
    if (loading && !descriptors) return $(Loader)

    // No descriptors
    if (descriptors.count === 0)
      return $(Fragment,
        $(EmptyLayout, {
          title: 'There are no faces yet',
          icon: 'facesEmpty',
          loading
        },
          $(FileButton, {
            fileRef: input => this.input = input,
            onChange: this.addPhoto,
            buttonProps: {
              bgColor: 'var(--violet)',
              width: 124,
              primary: true,
              text: 'Add face',
            }
          })
        ),
        isExtractView && this.renderExtractPanel(true))

    // Regular descriptors page
    const pagesCount = descriptors ? Math.ceil(descriptors.count / (vars.limit || 5)) : 0
    const paginationOptions = range(1, pagesCount + 1)
    return $(InnerLayout,
            $(Header,
              $(PaginationBar, {
                name: 'Faces',
                options: paginationOptions,
                value: vars.offset || 1,
                onChange: this.changePage,
                from: pagesCount
              }),
              $(HeaderButtons,
                // $(SelectContainer,
                //   $(Select, {
                //     value,
                //     options,
                //     onChange: noop,
                //     clearable: false,
                //     searchable: false,
                //     width: '100%'
                //   })
                // ),
                $(AddContainer,
                  $(Button, {
                      className: 'btnAddFromCam',
                      bgColor: 'var(--violet)',
                      width: 124,
                      isDisabled: true,
                      primary: true,
                    }, 'Add from cam'
                  ),
                  $(FileButton, {
                    fileRef: input => this.input = input,
                    onChange: this.addPhoto,
                    buttonProps: {
                      bgColor: 'var(--violet)',
                      width: 124,
                      primary: true,
                      text: 'Add face',
                    }
                  })
                ),
              ),
            ),
            $(Switch,
              $(Route, {
                path: `/faces/:id?`,
                render: () =>
                  $(FacesList, {photo, descriptors })
              })
            ),
            $(DetailsContainer,
              $(Switch,
                $(Route, {
                  path: `/faces/:id`,
                  render: () =>
                    $(DetailsPage, {
                      photo,
                      clearPhoto: this.clearPhoto
                    })
                }),
                $(Route, {
                  path: `/faces`,
                  render: () =>
                    $(EmptyDetails)
                }),
              ),
              isExtractView && this.renderExtractPanel()
            )
        )
  }
}

export default withRouter(graphql(DESCRIPTORS, {
  options: props => {
    const queryParams = getLocationQuery(props.location)
    return {
      fetchPolicy: 'cache-and-network',
      variables: getVariables(queryParams)
    }
  }
})(withConsumer(Faces)))

export const getVariables = (queryParams = {}) => ({
  limit: queryParams.limit || 12,
  offset: queryParams.offset || 1,
})


// WEBPACK FOOTER //
// ./src/pages/Faces/index.js